import { QualificationListJSON } from '@scale/shared/types/qualification/types';
import { useMutation, UseMutationResult } from 'react-query';
import apiFetch, { defaultApiFetchErrorHandler, HTTPError } from 'react-scale/lib/api-fetch';

export const useUpdateQualificationList = (
  onSuccess?: (data: QualificationListJSON) => void,
): UseMutationResult<QualificationListJSON, unknown, QualificationListJSON> => {
  return useMutation(
    ['updateQualificationList'],
    async (qualificationList: QualificationListJSON) => {
      const result = await apiFetch<QualificationListJSON>(
        null,
        `corp-api/scalers/qualifications/lists/${qualificationList._id}`,
        {
          method: 'PUT',
          body: {
            updatedQualificationList: qualificationList,
          },
        },
      );

      return result;
    },
    {
      onSuccess,
      onError: (err: HTTPError) => defaultApiFetchErrorHandler(err, { handleHttp: true }),
    },
  );
};
